import React, { FC } from 'react';
import { Menu, Dropdown, Space, Typography } from 'antd';
import sysend from 'sysend';

import { Avatar } from '~/components';
import {
  useAllAuthBusinesses,
  useCurrentAuthBusiness,
  useCurrentAuthProfileId,
} from '~/hooks/auth';
import { BusinessIcon } from '~/img';
import { auth } from '~/api/axios';
import { getBusinessKey } from '~/hooks/businesses';
import { queryClient } from '~/index';
import { useHistory, useLocation } from 'react-router-dom';

const SelectBusiness: FC = () => {
  const business = useCurrentAuthBusiness();
  const businessTitle = business?.title || '';

  return (
    <div className="Profile">
      <Dropdown trigger={['click']} overlay={<BusinessToSelect />} placement="bottomLeft" arrow>
        <Space size={14} className="Profile-DropdownArea">
          <Avatar size={42} icon={<BusinessIcon />} file={business?.icon} />
          {business && <Typography.Text className="Header-Title">{businessTitle}</Typography.Text>}
        </Space>
      </Dropdown>
    </div>
  );
};

const CLEAR_CACHE_CHANNEL = 'clearCacheChannel';
type ClearCachePayload = { prevProfileId: string };

const clearCache = (prevProfileId: string) => {
  void queryClient.removeQueries(getBusinessKey(prevProfileId));
  void queryClient.invalidateQueries();
};
sysend.on(CLEAR_CACHE_CHANNEL, (e: ClearCachePayload) => clearCache(e.prevProfileId));

const BusinessToSelect: FC = () => {
  const [currentBusinessId, setCurrentBusinessId] = useCurrentAuthProfileId();
  const { data } = useAllAuthBusinesses();
  const location = useLocation();
  const history = useHistory();

  const handleSelect = ({ key }: { key: string }) => {
    const prevProfileId = auth.getProfile();
    if (key === prevProfileId || !prevProfileId) return;
    const payload: ClearCachePayload = { prevProfileId };
    sysend.broadcast(CLEAR_CACHE_CHANNEL, payload);
    clearCache(prevProfileId);
    setCurrentBusinessId(key);
    history.replace(location.pathname);
    window.location.reload();
  };

  if (!currentBusinessId) return null;
  return (
    <Menu
      mode="inline"
      selectedKeys={[currentBusinessId]}
      selectable={false}
      onClick={handleSelect}
      className="menu-shadow"
    >
      {data?.map((item) => {
        return (
          <Menu.Item
            key={item.id}
            icon={<Avatar size={18} icon={<BusinessIcon />} file={item?.icon} />}
          >
            {item.title}
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

export default SelectBusiness;
